import axios from "axios";
const baseURL = "";

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": "fa-IR",
    chHostName: process.env.REACT_APP_CHHOSTNAME,
  },
});

axiosInstance.interceptors.request.use(
  async (req) => {
    return req;
  },
  (error) => {
    return Promise.reject({ error });
  }
);
export default axiosInstance;
